module.exports = __webpack_public_path__ + "images/category_lp/musical_instrument/new/mainView-pc_5fb86a0becc91e75dabc4196ad664d84.png";